export default {

    //Dialog Defaults
    ok: 'OK',
    cancel: 'Abbrechen',
    yes: 'Ja',
    no: 'Nein',
    close: 'Schließen',
    download: 'Download',

    //Dashboard.vue

    //Desktop.vue
    back: 'Zurück',
    home: 'Home',
    overview: 'Übersicht',
    overviewDesc: 'Ordner/Favoriten anzeigen',
    reload: 'Reload',
    more: 'Mehr',
    viewmodeList: 'Liste',
    viewmodeSymbols: 'Symbole',
    viewmodeCards: 'Karten',
    viewmodeDashboard: 'Dashboard',
    viewmodeTable: 'Tabelle',
    updateApp: 'APP Aktualisieren',
    updateAppDesc: 'Neu laden, Cache leeren.',
    export: 'Export',
    exportDesc: 'Download Abfrageergebnisse',
    exportXLSX: 'Download XLSX.',
    exportODS: 'Download ODS.',
    exportCSV: 'Download CSV.',
    changePW: 'Kennwort ändern',
    changePWDesc: 'Loginpasswort setzen.',
    changeLanguage: 'Sprache ändern',
    changeLanguageDesc: 'Sprache',
    changeSetting: 'Einstellungen',
    changeSettingDesc: 'Standardwerte setzen',
    help: 'Hilfe',
    helpDesc: 'Benutzerdokumentation',
    systemTest: 'Systemtest ausführen',
    systemTestDesc: 'Test der Systemvoraussetzungen',
    info: 'Info',
    version: 'Version',
    releaseNotes: 'Releasenotes',
    logout: 'Logout',
    loggedInAs: 'Angemeldet als',
    folder: 'Ordner',
    favorites: 'Favoriten',
    readingParamsError: 'Fehler beim Einlesen der Parameter.',
    favoriteToStart: 'Favorit zu "',
    favoriteToRemoved: '" entfernt',
    favoriteSaveError: 'Fehler beim Speichern des Favoriten.',
    favoriteListGetError: 'Fehler beim Lesen der Favoritenliste.',
    logoutError: 'Fehler beim Abmelden',
    logoutErrorDesc: 'Bitte überprüfen Sie Ihren Benutzernamen/Passwort.',

    //Detail.vue
    queries: 'Abfragen',
    formulars: 'Formulare',
    documents: 'Dokumente',
    framelinks: 'Framelinks',
    noElementsInFolder: 'Keine Ordner, Abfragen, Formulare, Dokumente vorhanden.',
    favoriteToSet: '" gesetzt',
    categoryListError: 'Fehler beim Einlesen der Kategorienliste.',
    queryListError: 'Fehler beim Einlesen der Abfragenliste.',

    //DocumentView.vue
    documentError: 'Fehler beim Laden des Dokumentes',

    //Formular.vue
    emptyFieldsDlgTitle: 'Nicht alle Felder befüllt',
    emptyFieldsDlgMessage: 'Es wurden nicht alle Pflichtfelder befüllt. Sie können dieses Formular später erneut öffnen und weiter bearbeiten. Möchten Sie speichern und schließen?',
    savingFormular: 'Speichere Formulardaten...',
    fileUploadError: 'Technischer Fehler beim Ausführen der File Uploads.',
    formularPersistError: 'Technischer Fehler beim Speichern des Formulares.',
    formularPersisted: 'Formular gespeichert.',
    downloadSuccess: 'Download erfolgreich.',
    downloadError: 'Download fehlgeschlagen.',
    pluginCallError: 'Fehler bei Pluginaufruf',
    validatingInputs: 'Überprüfe Eingaben...',
    presafeCheckError: 'Technischer Fehler beim Ausführen der PreSafeChecks.',
    dependantFieldRefreshError: 'Fehler beim Aktualisieren abhängiger Formularfelder.',
    formularLoading: 'Formular wird geladen',
    formularLoadingError: 'Fehler beim Einlesen der Formularfeld Defintionen.',
    formularNotSaved: 'Formulareingaben nicht gespeichert',
    formularNotSavedDesc: 'Verlassen ohne speichern?',

    //Framelink.vue
    framelinkLoadingError: 'Fehler beim Lesen des Framelinks.',

    //Login.vue
    reloadClearCache: 'Reload APP, Clear Cache',
    resetPassword: 'Kennwort zurücksetzen',
    login: 'Anmelden',
    username: 'Benutzername',
    password: 'Passwort',
    enterUsername: 'Bitte geben Sie Ihren Benutzernamen ein',
    passwordReset: 'Passwort zurückgesetzt',
    passwordResetDesc: 'Das Passwort wurde erfolgreich zurückgesetzt. Sie erhalten in Kürze ein neues Passwort per E-Mail.',
    loginError: 'Fehler beim Anmelden',
    loginErrorDesc: 'Bitte überprüfen Sie Ihren Benutzernamen/Passwort.',
    passwordResetError: 'Fehler beim Zurücksetzen des Passworts',
    passwordResetNameNotFound: 'Benutzername wurde nicht gefunden.',
    passwordResetNameNotUnique: 'Benutzername ist nicht einzigartig.',
    passwordResetMailFailed: 'Mailversand fehlgeschlagen.',
    passwordResetInvalidUsername: 'Die Person hat keinen gültigen Benutzernamen.',
    passwordResetInactiveUser: 'Der Benutzeraccount ist nicht aktiviert.',
    passwordResetNoUsername: 'Kein Benutzername angegeben.',
    passwordResetInvalidMail: 'Die Person besitzt keine gültige E-Mail Adresse.',

    //Parameter.vue
    useFormularStandardValues: 'Formular Standardwerte einsetzen',
    execute: 'Ausführen',
    filter: 'Filter',
    wrongParamValues: 'Falsche Parameterwerte',
    wrongParamValuesDesc: 'Bitte korrigieren Sie die fehlerhaften Parameterwerte.',

    //Query.vue
    queryTabParameter: 'Parameter',
    queryTabResult: 'Tabelle',
    queryTabDetail: 'Detail',
    queryTabEdit: 'Edit',
    queryTabChart: 'Chart',
    queryTabPlugin: 'Plugin',
    queryTabWebentity: 'Webentity',
    querySearch: 'Suche',
    restartAutorefresh: 'Restart Autorefresh',
    stopAutorefresh: 'Stop Autorefresh',
    fullscreen: 'Vollbild',
    fullscreenOnOff: 'Vollbildmodus ein/aus',
    resetChartZoom: 'Chart Zoom zurücksetzen',
    enableDisableRows: 'Spalten ein-/ausblenden',
    rowsPerPage: 'Zeilen / Seite',
    copyToClipboard: 'In Zwischenablage kopieren',
    showDetails: 'Details anzeigen',
    edit: 'Bearbeiten',
    queryExportODS: 'Export ODS',
    queryExportCSV: 'Export CSV',
    maxPostComma: 'Maximale Nachkommastellen: ',
    maxPreComma: 'Maximale Vorkommastellen: ',
    columnUpdateSuccess: '" erfolgreich aktualisiert',
    columnUpdateError: 'Fehler beim Update der Spalte "',
    dataExporting: 'Daten werden exportiert',
    downloadOf: 'Download von "',
    downloadOfSuccess: '" erfolgreich.',
    exportError: 'Fehler beim Export.',
    actionCallErrorTitle: 'Fehler beim Aufruf mit Query Parametern',
    actionCallErrorDescStart: 'Action mit nativename "',
    actionCallErrorDescEnd: '" existiert nicht.',
    actionExecuting: 'Aktion wird ausgeführt',
    actionCallErrorGlobal: 'Fehler beim Ausführen der Query Action.',
    actionParseError: 'Die Abfrage besitzt Spalten die Leerzeichen, Slash oder Backslash im Namen beinhalten. Diese Spalten konnten nicht geparst werden.',
    queryDefinitionError: 'Fehler beim Lesen der Abfragedefinition.',
    paramLoadingError: 'Fehler beim Einlesen der Parameter aus Query.vue',
    queryExecutionError: 'Fehler beim Ausführen der Abfrage',
    actionListError: 'Fehler beim Lesen der Query Actions.',
    fileDownloadError: 'Fehler beim Datei Download.',
    fileDownloadErrorNoSQLResult: 'BLOB SQL liefert keinen Download.',
    columnDomainErrorStart: 'Wertedomain zu "',
    columnDomainErrorEnd: '" konnte nicht gelesen werden.',
    noVisibleColumnsError: 'Achtung: Keine Spalten sichtbar. Bitte die Ergebnis Deklarationen prüfen.',
    exportNoColumnIncluded: 'Keine Ergebnisspalte wurde für den Export konfiguriert.',

    //QueryApp.vue

    //SingleRecordView.vue
    update: 'Update',
    noPrimaryKeyError: 'Für diese Abfrage ist kein Primary Key definiert.',
    updateSuccess: 'Updates erfolgreich',
    fieldUpdateError: 'Feld konnte nicht aktualisiert werden',
    valuedomainColumnStart: 'Wertedomain zu ',
    valuedomainColumnEnd: ' konnte nicht gelesen werden.',

    //Webentity.vue
    noWebentityDataFound: 'Keine Daten gefunden.',

    //fldRichtext.vue
    moveIn: 'Einrücken',
    moveOut: 'Ausrücken',
    moveInTooltip: 'Absatz einrücken',
    moveOutTooltip: 'Absatz ausrücken',
  }
